import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import { Injectable } from '@angular/core';
import { CanDeactivate, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { landingPageUrlMatcher } from '@app/landings/landing-routes';
import { SessionCookieService } from '@app/core/cookies';
import * as fromUser from '@app/core/user/store/reducers';
import { LogoutSuccess } from '@app/core/user/store/actions';
import { SetRoute, ClosePopin } from '@app/store';
import { map, take } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class IsLoggedGuard implements CanActivate, CanDeactivate<boolean> {
  private modalType: string;
  storeListener: Subscription;
  constructor(
    public dialog: MatDialog,
    private store: Store<any>,
    private platform: PlatformService,
    private sessionService: SessionCookieService
  ) {
    this.storeListener = this.store.pipe(select(fromUser.getAuthModalType)).subscribe(
      type => {
        this.modalType = type;
      },
      () => {}
    );
  }

  openDialog() {
    const config: any = {
      disableClose: false,
      maxWidth: 1280,
      data: {
        type: 'register',
        forced: true
      }
    };

    this.dialog
      .open(AuthModalComponent, config)
      .afterClosed()
      .subscribe(
        () => {
          this.store.dispatch(new ClosePopin({ name: this.modalType }));
          this.storeListener?.unsubscribe();
        },
        err => {}
      );
  }

  checkLoginStatus(): Observable<boolean> | boolean {
    return this.store.pipe(
      select(fromUser.isGuestUser),
      take(1),
      map(result => {
        if (result) {
          this.store.dispatch(new SetRoute(''));
          return result;
        } else {
          return this.isLoggedIn();
        }
      })
    );
  }

  isLoggedIn() {
    const isAuthenticated = this.sessionService.hasSession() && this.sessionService.hasUserId();

    if (!this.platform.isBrowser) {
      return true;
    }
    if (!isAuthenticated) {
      // Case when authenticated in store but cookie not present
      this.store.dispatch(new LogoutSuccess());
      this.openDialog();
    }
    return isAuthenticated;
  }

  canActivate(): boolean {
    return this.isLoggedIn();
  }

  canDeactivate(
    _component: boolean,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (this.isProductUrl(nextState.url) && !this.isLandingPage(nextState.url)) {
      return this.checkLoginStatus();
    }
    return true;
  }

  isProductUrl(url: string): boolean {
    return /.*\/.*\/.*\/.*-([0-9]+)\.shtml$/.test(url);
  }

  isLandingPage(url: string): boolean {
    return landingPageUrlMatcher(this.urlStringToUrlSegment(url)) !== null;
  }

  urlStringToUrlSegment(url: string): UrlSegment[] {
    return url
      .replace(/^\/|\/$/g, '')
      .split('/')
      .map(e => new UrlSegment(e, {}));
  }
}
